import { BaseCameraApi } from '@inter-ikea-storageone/range';
export class KallaxCameraApi extends BaseCameraApi {
}
//# sourceMappingURL=KallaxCameraApi.js.map